export function initialize(module: ng.IModule) {
    module.filter("encodeURIComponent", [encodeURIComponentFilter]);
}

function encodeURIComponentFilter() {
    return encodeURIComponent;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/encodeURIComponent.filter.ts